export default ({request}) => ({
  masterYarnLeftListApi(data = {}) {
    return request({
      url: '/master/masterCategory/yarnList',
      method: 'post',
      data,
    })
  },
  masterYarnListApi(data = {}) {
    return request({
      url: '/master/masterYarn/list',
      method: 'post',
      data,
    })
  },
  masterYarnDetailApi(data = {}) {
    return request({
      url: '/master/masterYarn/detail',
      method: 'post',
      data,
    })
  },
  masterYarnDelApi(data = {}) {
    return request({
      url: '/master/masterYarn/del',
      method: 'post',
      data,
    })
  },
  masterYarnSaveApi(data = {}) {
    return request({
      url: '/master/masterYarn/save',
      method: 'post',
      data,
    })
  },
})
